import {useEffect} from 'react';
import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API, PrintedCardsResponse} from '@chekin/api';

type Props = {
  reservationId?: string;
  enabled?: boolean;
  onSuccess?: (data: PrintedCardsResponse) => void;
};

function useFetchPrintedCards({reservationId, enabled = true, onSuccess}: Props) {
  const query = useQuery({
    queryKey: [QUERY_CACHE_KEYS.printedCards, reservationId],
    queryFn: () => API.kiosko.getPrintedCards(reservationId!),
    enabled: Boolean(reservationId) && enabled,
  });

  useEffect(() => {
    if (query.data) {
      onSuccess?.(query.data);
    }
  }, [query.data, onSuccess]);

  return query;
}

export {useFetchPrintedCards};
